// @generated by protoc-gen-es v1.2.0 with parameter "target=ts,import_extension=.ts"
// @generated from file protogen/review.proto (package protogen, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";

/**
 * @generated from enum protogen.ReviewStatus
 */
export enum ReviewStatus {
  /**
   * @generated from enum value: REVIEW_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: REVIEW_STATUS_PENDING = 1;
   */
  PENDING = 1,

  /**
   * @generated from enum value: REVIEW_STATUS_APPROVED = 2;
   */
  APPROVED = 2,

  /**
   * @generated from enum value: REVIEW_STATUS_HIDDEN = 3;
   */
  HIDDEN = 3,
}
// Retrieve enum metadata with: proto3.getEnumType(ReviewStatus)
proto3.util.setEnumType(ReviewStatus, "protogen.ReviewStatus", [
  { no: 0, name: "REVIEW_STATUS_UNSPECIFIED" },
  { no: 1, name: "REVIEW_STATUS_PENDING" },
  { no: 2, name: "REVIEW_STATUS_APPROVED" },
  { no: 3, name: "REVIEW_STATUS_HIDDEN" },
]);

/**
 * @generated from enum protogen.ReviewType
 */
export enum ReviewType {
  /**
   * @generated from enum value: REVIEW_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: REVIEW_TYPE_CLIENT = 1;
   */
  CLIENT = 1,

  /**
   * @generated from enum value: REVIEW_TYPE_ADMIN = 2;
   */
  ADMIN = 2,

  /**
   * @generated from enum value: REVIEW_TYPE_SELF = 3;
   */
  SELF = 3,
}
// Retrieve enum metadata with: proto3.getEnumType(ReviewType)
proto3.util.setEnumType(ReviewType, "protogen.ReviewType", [
  { no: 0, name: "REVIEW_TYPE_UNSPECIFIED" },
  { no: 1, name: "REVIEW_TYPE_CLIENT" },
  { no: 2, name: "REVIEW_TYPE_ADMIN" },
  { no: 3, name: "REVIEW_TYPE_SELF" },
]);

/**
 * @generated from message protogen.Review
 */
export class Review extends Message<Review> {
  /**
   * @generated from field: string ref = 1;
   */
  ref = "";

  /**
   * @generated from field: int64 createdSec = 2;
   */
  createdSec = protoInt64.zero;

  /**
   * @generated from field: int64 lastUpdatedSec = 3;
   */
  lastUpdatedSec = protoInt64.zero;

  /**
   * @generated from field: string submitterRef = 4;
   */
  submitterRef = "";

  /**
   * @generated from field: string subjectRef = 5;
   */
  subjectRef = "";

  /**
   * @generated from field: string displayName = 6;
   */
  displayName = "";

  /**
   * @generated from field: string text = 7;
   */
  text = "";

  /**
   * @generated from field: float starCount = 8;
   */
  starCount = 0;

  /**
   * @generated from field: protogen.ReviewStatus status = 9;
   */
  status = ReviewStatus.UNSPECIFIED;

  /**
   * @generated from field: string subjectName = 10;
   */
  subjectName = "";

  /**
   * @generated from field: protogen.ReviewType reviewType = 11;
   */
  reviewType = ReviewType.UNSPECIFIED;

  constructor(data?: PartialMessage<Review>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.Review";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "ref", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "createdSec", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "lastUpdatedSec", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "submitterRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "subjectRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "displayName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "starCount", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 9, name: "status", kind: "enum", T: proto3.getEnumType(ReviewStatus) },
    { no: 10, name: "subjectName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "reviewType", kind: "enum", T: proto3.getEnumType(ReviewType) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Review {
    return new Review().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Review {
    return new Review().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Review {
    return new Review().fromJsonString(jsonString, options);
  }

  static equals(a: Review | PlainMessage<Review> | undefined, b: Review | PlainMessage<Review> | undefined): boolean {
    return proto3.util.equals(Review, a, b);
  }
}

